export default {
  TW: '台湾',
  US: 'アメリカ合衆国',
  AG: 'アンティグア・バーブーダ',
  AI: 'アンギラ',
  AS: 'アメリカ領サモア',
  BB: 'バルバドス',
  BM: 'バミューダ',
  BS: 'バハマ',
  CA: 'カナダ',
  DM: 'ドミニカ',
  DO: 'ドミニカ共和国',
  GD: 'グレナダ',
  GU: 'グアム',
  JM: 'ジャマイカ',
  KN: 'セントクリストファー・ネイビス',
  KY: 'ケイマン諸島',
  LC: 'セントルシア',
  MP: '北マリアナ諸島',
  MS: 'モントセラト',
  PR: 'プエルトリコ',
  SX: 'オランダ領セントマーチン',
  TC: 'タークス・カイコス諸島',
  TT: 'トリニダード・トバゴ',
  VC: 'セントビンセント・グレナディーン',
  VG: 'イギリス領ヴァージン諸島',
  VI: 'アメリカ領ヴァージン諸島',
  RU: 'ロシア',
  KZ: 'カザフスタン',
  EG: 'エジプト',
  ZA: '南アフリカ',
  GR: 'ギリシャ',
  NL: 'オランダ',
  BE: 'ベルギー',
  FR: 'フランス',
  ES: 'スペイン',
  HU: 'ハンガリー',
  IT: 'イタリア',
  VA: 'バチカン',
  RO: 'ルーマニア',
  CH: 'スイス',
  AT: 'オーストリア',
  GB: 'イギリス',
  GG: 'ガーンジー',
  IM: 'マン島',
  JE: 'ジャージー',
  DK: 'デンマーク',
  SE: 'スウェーデン',
  NO: 'ノルウェー',
  SJ: 'スヴァールバル諸島・ヤンマイエン島',
  PL: 'ポーランド',
  DE: 'ドイツ',
  PE: 'ペルー',
  MX: 'メキシコ',
  CU: 'キューバ',
  AR: 'アルゼンチン',
  BR: 'ブラジル',
  CL: 'チリ',
  CO: 'コロンビア',
  VE: 'ベネズエラ',
  MY: 'マレーシア',
  AU: 'オーストラリア',
  CC: 'ココス（キーリング）諸島',
  CX: 'クリスマス島',
  ID: 'インドネシア',
  PH: 'フィリピン',
  NZ: 'ニュージーランド',
  SG: 'シンガポール',
  TH: 'タイ',
  JP: '日本',
  KR: '韓国',
  VN: 'ベトナム',
  CN: '中国',
  TR: 'トルコ',
  IN: 'インド',
  PK: 'パキスタン',
  AF: 'アフガニスタン',
  LK: 'スリランカ',
  MM: 'ミャンマー',
  IR: 'イラン',
  SS: '南スーダン',
  MA: 'モロッコ',
  EH: '西サハラ',
  DZ: 'アルジェリア',
  TN: 'チュニジア',
  LY: 'リビア',
  GM: 'ガンビア',
  SN: 'セネガル',
  MR: 'モーリタニア',
  ML: 'マリ',
  GN: 'ギニア',
  CI: 'コートジボワール',
  BF: 'ブルキナファソ',
  NE: 'ニジェール',
  TG: 'トーゴ',
  BJ: 'ベナン',
  MU: 'モーリシャス',
  LR: 'リベリア',
  SL: 'シエラレオネ',
  GH: 'ガーナ',
  NG: 'ナイジェリア',
  TD: 'チャド',
  CF: '中央アフリカ共和国',
  CM: 'カメルーン',
  CV: 'カーボベルデ',
  ST: 'サントメ・プリンシペ',
  GQ: '赤道ギニア',
  GA: 'ガボン',
  CG: 'コンゴ共和国',
  CD: 'コンゴ民主共和国',
  AO: 'アンゴラ',
  GW: 'ギニアビサウ',
  IO: 'イギリス領インディアンオーシャン地域',
  AC: 'アセンション島',
  SC: 'セーシェル',
  SD: 'スーダン',
  RW: 'ルワンダ',
  ET: 'エチオピア',
  SO: 'ソマリア',
  DJ: 'ジブチ',
  KE: 'ケニア',
  TZ: 'タンザニア',
  UG: 'ウガンダ',
  BI: 'ブルンジ',
  MZ: 'モザンビーク',
  ZM: 'ザンビア',
  MG: 'マダガスカル',
  RE: 'レユニオン',
  YT: 'マヨット',
  ZW: 'ジンバブエ',
  NA: 'ナミビア',
  MW: 'マラウイ',
  LS: 'レソト',
  BW: 'ボツワナ',
  SZ: 'スワジランド',
  KM: 'コモロ',
  SH: 'セントヘレナ',
  TA: 'トリスタンダクーニャ',
  ER: 'エリトリア',
  AW: 'アルバ',
  FO: 'フェロー諸島',
  GL: 'グリーンランド',
  GI: 'ジブラルタル',
  PT: 'ポルトガル',
  LU: 'ルクセンブルク',
  IE: 'アイルランド',
  IS: 'アイスランド',
  AL: 'アルバニア',
  MT: 'マルタ',
  CY: 'キプロス',
  FI: 'フィンランド',
  AX: 'オーランド諸島',
  BG: 'ブルガリア',
  LT: 'リトアニア',
  LV: 'ラトビア',
  EE: 'エストニア',
  MD: 'モルドバ',
  AM: 'アルメニア',
  BY: 'ベラルーシ',
  AD: 'アンドラ',
  MC: 'モナコ',
  SM: 'サンマリノ',
  UA: 'ウクライナ',
  RS: 'セルビア',
  ME: 'モンテネグロ',
  XK: 'コソボ',
  HR: 'クロアチア',
  SI: 'スロベニア',
  BA: 'ボスニア・ヘルツェゴビナ',
  MK: '北マケドニア',
  CZ: 'チェコ',
  SK: 'スロバキア',
  LI: 'リヒテンシュタイン',
  FK: 'フォークランド諸島',
  BZ: 'ベリーズ',
  GT: 'グアテマラ',
  SV: 'エルサルバドル',
  HN: 'ホンジュラス',
  NI: 'ニカラグア',
  CR: 'コスタリカ',
  PA: 'パナマ',
  PM: 'サンピエール島・ミクロン島',
  HT: 'ハイチ',
  GP: 'グアドループ',
  BL: 'サン・バルテルミー',
  MF: 'サン・マルタン',
  BO: 'ボリビア',
  GY: 'ガイアナ',
  EC: 'エクアドル',
  GF: 'フランス領ギアナ',
  PY: 'パラグアイ',
  MQ: 'マルティニーク',
  SR: 'スリナム',
  UY: 'ウルグアイ',
  CW: 'クーラソ',
  BQ: 'オランダ領カリブ',
  TL: '東ティモール',
  NF: 'ノーフォーク島',
  BN: 'ブルネイ',
  NR: 'ナウル',
  PG: 'パプアニューギニア',
  TO: 'トンガ',
  SB: 'ソロモン諸島',
  VU: 'バヌアツ',
  FJ: 'フィジー',
  PW: 'パラオ',
  WF: 'ウォリス・フツナ',
  CK: 'クック諸島',
  NU: 'ニューエ',
  WS: 'サモア',
  KI: 'キリバス',
  NC: 'ニューカレドニア',
  TV: 'ツバル',
  PF: 'フランス領ポリネシア',
  TK: 'トケラウ',
  FM: 'ミクロネシア連邦',
  MH: 'マーシャル諸島',
  KP: '北朝鮮',
  HK: '香港',
  MO: 'マカオ',
  KH: 'カンボジア',
  LA: 'ラオス',
  BD: 'バングラデシュ',
  MV: 'モルディブ',
  LB: 'レバノン',
  JO: 'ヨルダン',
  SY: 'シリア',
  IQ: 'イラク',
  KW: 'クウェート',
  SA: 'サウジアラビア',
  YE: 'イエメン',
  OM: 'オマーン',
  PS: 'パレスチナ',
  AE: 'アラブ首長国連邦',
  IL: 'イスラエル',
  BH: 'バーレーン',
  QA: 'カタール',
  BT: 'ブータン',
  MN: 'モンゴル',
  NP: 'ネパール',
  TJ: 'タジキスタン',
  TM: 'トルクメニスタン',
  AZ: 'アゼルバイジャン',
  GE: 'ジョージア',
  KG: 'キルギス',
  UZ: 'ウズベキスタン',
} as Record<string, string>;
